Vue.component("chartTab", {
    template: '<div id="tab-container" :style="{paddingLeft: left}"><div v-for="tab, selection in tabs" :id="tab" :class="{tab, selected:selected == selection}" @click="change(selection)">{{\'statistic.graph.tabs.\' + tab | t }}</div></div>',
    data: function () {
        return {
            chartArea: chartHandler.getArea(),
            selected: 0,
            left: '0px',
            top: '0px'
        }
    },
    props: {
        tabs: {
            type: Array,
            default: function () {
                return [
                    'counter',
                    'timer'
                ];
            }
        }
    },
    methods: {
        change: function(selection) {
            this.selected = selection;
            bus.$emit('GRAPH_TYPE', this.tabs[selection]);
        }
    },
    watch: {
        'chartArea.left': function(value) {
            this.left = Math.round(value) + 'px';
        },
        'chartArea.top': function(value) {
            this.top = Math.round(value) + 'px';
        },
    }
});
